// extracted by mini-css-extract-plugin
export default {"gap":"o5BKIK"};